import AbstractService from '@/services/abstractService'

class PortfolioService extends AbstractService {
    endpoint = 'clients'

    index() {
      return this.http.get(this.endpoint, { params: { dashboard: true } })
    }

    clientProjects(id) {
      return this.http.get(`${this.endpoint}/${id}/projects`, { params: { dashboard: true } })
    }

    clientRepresintatives(id) {
      return this.http.get(`representatives/clients/${id}`, { params: { dashboard: true } })
    }

    post(data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.post(this.endpoint, formData)
    }

    put(data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()

      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.put(`${this.endpoint}/${data.id}`, formData)
    }

    delete(data) {
      console.log('data', data)
      return this.http.delete(`${this.endpoint}/${data}`)
    }

    changePassword(data) {
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.post(`${this.endpoint}/${data.id}/changePassword`, formData)
    }

    assignRepresentative(id, data) {
      return this.http.post(`${this.endpoint}/${id}/representative`, data)
    }

    unAssign(clientId, representativeId) {
      return this.http.delete(`${this.endpoint}/${clientId}/representative/${representativeId}`)
    }

    editAssignedReprsentative(id, data) {
      return this.http.put(`${this.endpoint}/${id}/representative/${data.representative_id}`, data)
    }

    changeRole(id) {
      return this.http.post(`${this.endpoint}/${id}/role`)
    }
}

const Service = new PortfolioService()

export default Service
